var exports = {
  "m": "languageDot__vjQD94",
  "D": "languageDotCompact___uYJgV",
};

module.exports = exports;
